// extracted by mini-css-extract-plugin
export default {"Modal":"modalStyles_Modal__qk2Jd","background":"modalStyles_background__IYpzx","ModalContent":"modalStyles_ModalContent__5TBkL","ModalHeader":"modalStyles_ModalHeader__S4VDz"};